import { useExportStats } from "../../admin/hooks/useExportRecords";

export function ExportStatusCard() {
  const { stats, isLoading } = useExportStats();

  const inProgress = (stats["pending"] ?? 0) + (stats["in_progress"] ?? 0);
  const failed = stats["failed"] ?? 0;
  const completed = stats["completed"] ?? 0;
  const total = inProgress + failed + completed;
  const successRate = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="dashboard-widget" data-testid="export-status-card">
      <p className="dashboard-widget-title">Export Status</p>
      {isLoading ? (
        <div className="dashboard-loading">
          <div className="loading-spinner" />
        </div>
      ) : (
        <div className="activity-stats">
          <div className="activity-stat">
            <span className="activity-stat-value">{inProgress}</span>
            <span className="activity-stat-label">In Progress</span>
          </div>
          <div className="activity-stat">
            <span className={`activity-stat-value ${failed > 0 ? "export-stat-value--failed" : ""}`}>
              {failed}
            </span>
            <span className="activity-stat-label">Failed</span>
          </div>
          <div className="activity-stat">
            <span className="activity-stat-value">{successRate}%</span>
            <span className="activity-stat-label">Success Rate</span>
          </div>
        </div>
      )}
    </div>
  );
}
